<cb-table
    [loaded]="true"
    [stringColumns]="columnsNames"
    [tableLabel]="label"
    class="cb-margin-top-2x"
>
    <tbody cbTableBody>
        @for (item of value; track item) {
            @if (!isEmpty(item)) {
                <tr>
                    @for (column of columnsValues; track column) {
                        <td>
                            @switch (column.type) {
                                @case ('text') {
                                    {{ item[column.valueProp] }}
                                }
                                @case ('checkbox') {
                                    <mat-icon class="cb-grey">
                                        {{
                                            item[column.valueProp]
                                                ? 'check_box'
                                                : 'check_box_outline_blank'
                                        }}
                                    </mat-icon>
                                }
                            }
                        </td>
                    }
                    <td cbTableShrinkCol cbTableStickyCol="end" class="layoutGap-4">
                        <button mat-icon-button (click)="editItemClicked(item)">
                            <mat-icon>edit</mat-icon>
                        </button>
                        <button mat-icon-button (click)="deleteItemClicked(item)">
                            <mat-icon>remove_circle</mat-icon>
                        </button>
                    </td>
                </tr>
            }
        }
        <tr>
            <td colspan="5" [style.textAlign]="'right'">
                <button mat-icon-button (click)="newItemClicked()">
                    <mat-icon>add</mat-icon>
                </button>
            </td>
        </tr>
    </tbody>
</cb-table>
